import { useQuery } from 'react-query'

// key enum
import apiKey from 'src/core/services/base/apiKey'

// hooks
import { useLanguage } from 'src/core/components/LanguageProvider/hooks'
import { useUnAuthAlert } from 'src/shared/hooks/useUnAuthAlert'

import { getOrderOthers } from './index'

export default function useGetOrderOther(params?: { language: string }) {
  const { language: _language } = useLanguage()
  const language = (params?.language || _language) as string

  const { openUnAuthAlertMemoWithContent } = useUnAuthAlert()

  const fetchFunction = () => getOrderOthers({ language }, openUnAuthAlertMemoWithContent)

  const queryKey = [apiKey.getOrderOthers, language]

  return {
    queryKey,
    ...useQuery(queryKey, fetchFunction, {
      retry: 3,
      refetchOnMount: true,
    }),
  }
}
